import React, { useEffect, useState } from 'react';

// mui
import { Box, List, Stack } from '@mui/material';

// api
import { AdminObjectAdd, AdminObjectList, AdminObjectRemove, AdminObjectUpdate } from '../../../api';

import { def } from '@goldblack/shared';

// components
import { FilterItem, AccountFiltersFilterInfoPanel, AdminMenuBar, cloneObject } from '../..';

// client-shared
import { storage } from '@goldblack/client-storage';

function AccountFiltersFilters() {
    const { account } = storage.transience.getValue();
    const [selectedIndex, setSelectedIndex] = useState(0);

    function getFilter() {
        return account.filter.data?.length > 0 ? account.filter.data[selectedIndex] : null;
    }

    const clickNew = () => {
        AdminObjectAdd('account', 'filter', { name: 'Untitled' }, () => {
            setSelectedIndex(account.filter.data.length);
        });
    };

    const clickUpdate = () => {
        AdminObjectUpdate('account', 'filter', getFilter());
    };

    const clickDelete = () => {
        AdminObjectRemove('account', 'filter', getFilter()._id);
    };

    const clickSetActive = () => {
        const filter = cloneObject(getFilter());
        filter.status = def.FilterStatus.ACTIVE;
        storage.transience.updateState('account.filter.data', (f) => f._id === filter._id, filter);
    };

    const clickSetInactive = () => {
        const filter = cloneObject(getFilter());
        filter.status = def.FilterStatus.INACTIVE;
        storage.transience.updateState('account.filter.data', (f) => f._id === filter._id, filter);
    };

    const clickToggleSensitive = () => {
        const filter = cloneObject(getFilter());
        filter.sensitive = filter.sensitive ? 0 : 1;
        storage.transience.updateState('account.filter.data', (f) => f._id === filter._id, filter);
    };

    useEffect(() => {
        if (account.filter.data.length === 0) {
            AdminObjectList('account', 'filter');
        }
    }, []);

    const currentFilter = getFilter();

    const apiItems = [
        { label: 'New', onClick: clickNew },
        { label: 'Update', onClick: clickUpdate },
        { label: 'Delete', onClick: clickDelete },
    ];

    const editItems = [
        { label: 'Set Active', onClick: clickSetActive },
        { label: 'Set Inactive', onClick: clickSetInactive },
        { label: 'Toggle Sensitive', onClick: clickToggleSensitive },
    ];

    return (
        <Stack direction='column' sx={{ p: 0, m: 0, width: '100%', height: '100%', minHeight: 0 }}>
            <AdminMenuBar apiItems={apiItems} editItems={editItems} />
            <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
                {/* Left column */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        borderRight: 1,
                        borderColor: 'primary.main',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }}>
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'auto',
                            borderBottom: 1,
                            borderColor: 'primary.main',
                            boxSizing: 'border-box',
                        }}>
                        <List>
                            {account.filter.data.map((filter, index) => (
                                <FilterItem
                                    key={filter._id}
                                    filter={filter}
                                    onClick={() => setSelectedIndex(index)}
                                    index={index}
                                    selected={selectedIndex === index}
                                />
                            ))}
                        </List>
                    </Box>
                </Box>
                {/* Right column */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }}>
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'auto',
                            borderBottom: 1,
                            borderColor: 'primary.main',
                            boxSizing: 'border-box',
                        }}>
                        {currentFilter && <AccountFiltersFilterInfoPanel filter={currentFilter} />}
                    </Box>
                </Box>
            </Box>
        </Stack>
    );
}

export { AccountFiltersFilters };
